<template>
  <div style="margin: 20px">
    <b-row class="nopadding">
      <fp-input
        style="margin: 0px 5px"
        :label="$t('base.basic.filter')"
        @change="filterList"
        v-model="filter"
        class="eh-fix-filter-input-width"
      />
      <fp-date-range-button
        :label="$t('healthProfessional.questionnaires.waitingTab.givenDate')"
        v-model="assignedDateFilter"
        @change="filterList"
      />
      <fp-date-range-button
        :label="$t('healthProfessional.questionnaires.waitingTab.filledDate')"
        v-model="filledDateFilter"
        @change="filterList"
      />
    </b-row>
    <fp-table-list
      class="questionnaires-to-patient-table"
      :bordered="true"
      :items="filteredFilledQuestionnaireListFields"
      :fields="filledQuestionnaireListFields"
    >
      <template #Title="row">
        {{ getTextByLanguage(row.item.Title, row.item.Languages) }}
      </template>
      <template #ProgressPercentage="row">
        <b-progress :value="row.item.FillingRate" :max="100"></b-progress>
        <div style="text-align: center">
          {{ row.item.FillingRate ? row.item.FillingRate + "%" : "0%" }}
        </div>
      </template>
      <template #Evaluating="row">
        <router-link
          :to="{
            name: 'WebAppSpecialistEvaluatingQuestionnaire',
            query: { Id: row.item.FormInstanceId },
          }"
          ><b-button
            :disabled="!['Filled', 'UnderEvaluation'].includes(row.item.Status)"
            >{{
              $t("healthProfessional.questionnaires.waitingTab.evaulate")
            }}</b-button
          ></router-link
        >
      </template>
      <template #UserId="row">
        {{ row.item.Patient.Name }}
      </template>
      <template #UserSsn="row">
        {{ row.item.Patient.Ssn }}
      </template>
      <template #UserBirthday="row">
        {{
          $convertDateToString(
            row.item.Patient.PatientDateOfBirth,
            "YYYY-MM-DD"
          )
        }}
      </template>
      <template #CreatedAt="row">
        {{ $convertDateToString(row.item.CreatedAt, "YYYY-MM-DD HH:mm") }}
      </template>
      <template #FilledDate="row">
        {{ $convertDateToString(row.item.FilledDate, "YYYY-MM-DD HH:mm") }}
      </template>
    </fp-table-list>
  </div>
</template>
<script>
import moment from "moment";
import { ProjectLogic } from "../../../Logic/Backend/project.js";
import { FormLogic } from "../../../Logic/Backend/form";
export default {
  name: "QuestionnaireWaitForEvaluateList",
  data() {
    return {
      patientList: [],
      filledQuestionnaireList: [],
      filteredFilledQuestionnaireListFields: [],
      filledQuestionnaireListFields: [
        {
          key: "UserId",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.patient"
          ),
        },
        {
          key: "UserSsn",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.patientSsn"
          ),
        },
        {
          key: "UserBirthday",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.patientBirth"
          ),
        },
        {
          key: "Title",
          label: this.$t("healthProfessional.questionnaires.waitingTab.title"),
        },
        {
          key: "ProgressPercentage",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.progress"
          ),
        },
        {
          key: "CreatedAt",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.givenDate"
          ),
        },
        {
          key: "FilledDate",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.filledDate"
          ),
        },
        {
          key: "Deadline",
          label: this.$t(
            "healthProfessional.questionnaires.waitingTab.deadline"
          ),
        },
        { key: "Evaluating", label: "" },
      ],
      filter: null,
      assignedDateFilter: null,
      filledDateFilter: null,
    };
  },
  methods: {
    getTextByLanguage(textObject, languages) {
      if (languages.includes(this.$i18n.locale)) {
        return textObject[this.$i18n.locale];
      } else if (languages.includes("en")) {
        return textObject.en;
      } else {
        return textObject[languages[0]];
      }
    },
    filterList() {
      this.filteredFilledQuestionnaireListFields = this.filledQuestionnaireList;
      if (this.filter) {
        this.filteredFilledQuestionnaireListFields = this.$filterList(
          this.filter,
          this.filledQuestionnaireList,
          ["Title", "Patient.Name", "Patient.Ssn", "Patient.PatientDateOfBirth"]
        );
      }
      if (this.assignedDateFilter) {
        this.filteredFilledQuestionnaireListFields =
          this.filteredFilledQuestionnaireListFields.filter((task) => {
            if (this.assignedDateFilter.from && this.assignedDateFilter.to) {
              return moment(task.CreatedAt).isBetween(
                this.assignedDateFilter.from,
                this.assignedDateFilter.to,
                undefined,
                "[]"
              );
            } else if (this.assignedDateFilter.from) {
              return moment(task.CreatedAt).isSameOrAfter(
                moment(this.assignedDateFilter.from)
              );
            } else if (this.assignedDateFilter.to) {
              return moment(task.CreatedAt).isSameOrBefore(
                moment(this.assignedDateFilter.to)
              );
            }
            return true;
          });
      }
      if (this.filledDateFilter) {
        this.filteredFilledQuestionnaireListFields =
          this.filteredFilledQuestionnaireListFields.filter((task) => {
            if (this.filledDateFilter.from && this.filledDateFilter.to) {
              return moment(task.FilledDate).isBetween(
                this.filledDateFilter.from,
                this.filledDateFilter.to,
                undefined,
                "[]"
              );
            } else if (this.filledDateFilter.from) {
              return moment(task.FilledDate).isSameOrAfter(
                moment(this.filledDateFilter.from)
              );
            } else if (this.filledDateFilter.to) {
              return moment(task.FilledDate).isSameOrBefore(
                moment(this.filledDateFilter.to)
              );
            }
            return true;
          });
      }
    },
    //beteg lista kérés
    async getPatientList() {
      //kérés indítás
      const patientListResult = await ProjectLogic.getProjectSubordinates(
        this.$loggedUser.SelectedProject.ProjectId
      );
      //sikeres kérés?
      if (!patientListResult.Code) {
        //beteg lista frissítés
        this.patientList = patientListResult;
      } else {
        this.$bvToast.toast(patientListResult.Message, {
          title: this.$t("requestResponse.project.errorGetProjectSubordinates"),
          variant: "danger",
          solid: true,
          AutoHideDelay: 10000,
        });
      }
    },
    //kiértékelésre váró kérdőívek listája
    async getAssignedFilledQuestionnaireList() {
      //beteg lista betöltés
      await this.getPatientList();
      //kérés indítás
      const questionnaireListResult = await FormLogic.getFormInstanceHeader({
        EvaluatorId: this.$loggedUser.UserId,
        FormCategory: "Questionnaire",
        EvaluationMethod: "Manual",
        ProjectId: this.$loggedUser.SelectedProject.ProjectId,
      });
      //sikers kérés?
      if (!questionnaireListResult.Code) {
        //kiértékelésre váró kérdőív lista frissítés
        questionnaireListResult.forEach((quest) => {
          const patient = this.patientList.find(
            (y) => y.UserId == quest.SubjectId
          );
          if (patient) {
            quest.Patient = {
              Name: patient.Name,
              Ssn: patient.Ssn,
              PatientDateOfBirth: patient.PatientDateOfBirth,
            };
          }
        });
        this.filledQuestionnaireList =
          this.filteredFilledQuestionnaireListFields =
            questionnaireListResult.filter(
              (form) =>
                form.Patient &&
                [
                  this.$enums.QuestionnaireStatus.Filled.Value,
                  this.$enums.QuestionnaireStatus.UnderEvaluation.Value,
                ].includes(form.Status)
            );
      } else {
        this.$bvToast.toast(questionnaireListResult.Message, {
          title: this.$t("requestResponse.basic.errorGetNamedList", {
            name: this.$t(
              "healthProfessional.questionnaires.waitingTab.errorWaitingName"
            ),
          }),
          variant: "danger",
          solid: true,
          AutoHideDelay: 10000,
        });
      }
    },
  },
  //betöltéskor egyszer lefut
  async mounted() {
    //kiértékelésre váró kérdőívek betöltése
    await this.getAssignedFilledQuestionnaireList();
  },
};
</script>
<style scoped>
.date-picker-calendar-quest {
  position: absolute;
  top: 40px;
  right: -100px;
  background: white;
  border: solid 3px #627183;
  border-radius: 10px;
  text-align: center;
  z-index: 10;
}
</style>